export const getAircraftImageUrl = (aircraftId: string | undefined): string => {
  if (!aircraftId) {
    return "";
  }
  
  // Always use the CDN URL for consistent image loading
  return `https://static.airplx.com/${aircraftId}.png`;
};